// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * We include a request object that can be sent to request the 
 * properties in a given way. For example, for timestamp-based meta-
 * properties, we can request a range with a max number of properties.
 * In the future, perhaps other kinds of properties could have different
 * kinds of requests. For example, we could have a request for "2-D" 
 * properties if we want geographically mapped properties, or if
 * we want to create an "infinite canvas" of files, we create a 2D 
 * metaproperty for folders that lets us request files in a given area.
 */
export enum EntityPropertySelectionRegionKindBuf {
  /**
   * A section selection is a selection of properties between two keys
   * in a given property group. This is the most common kind of selection.
   */
  Section = 0,

  /**
   * A timeline selection is a selection of properties for a given time
   * range. A timeline can only be merged with another overlapping timeline
   * with the same direction. This is a very restrictive kind of selection so
   * we should be wary and only use it for timeline-style properties such as
   * comments. Note that we can't
   */
  Timeline = 1
}
